module.exports = __webpack_public_path__ + "static/media/Ramona Avenue, Albany, CA6.8a1599e1.jpg";